<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    offset-y
    left
    transition="slide-y-transition"
    style=""
  >
    <template #activator="{ on }">
      <v-btn
        text
        :icon="$vuetify.breakpoint.smAndDown"
        v-on="on"
        v-show="hasHotelAssigned"
      >
        <span
          class="text-truncate d-md-inline d-sm-none"
          style="max-width: 200px"
          :class="[($vuetify.rtl ? 'mr-1' : 'ml-1') + (IsDemoHotel(selectedHotel) ? ' red--text' : '')]"
        >{{ selectedHotel.name }}</span>
        <v-icon
          class="d-sm-inline d-md-none"
          style="margin-bottom: 5px;"
        >
          mdi-domain
        </v-icon>
        <v-icon
          right
          class="d-md-inline d-sm-none"
        >
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>
    <v-card
      max-height="500px"
      width="400px"
      style="
        background: white;
        padding: 10px 0;
        border: solid 1px #d6d0d0 !important;
      "
    >
      <v-text-field
        v-if="showSearch"
        ref="searchField"
        v-model="searchKeyword"
        placeholder="Filter hotel..."
        flat
        hide-details
        rounded
        prepend-inner-icon="mdi-magnify"
        class="mx-1 mb-1"
      />
      <v-list
        dense
        nav
        style="max-height: 400px; overflow: auto"
      >
        <v-list-item
          v-for="hotel in filteredHotels"
          :key="hotel.id"
          @click="SetHotel(hotel)"
        >
          <v-list-item-title>
            <v-icon
              v-if="hotel.default_hotel"
              style="color: darkorange; font-size: small; top: -2px;"
            >
              mdi-star
            </v-icon>
            <span :class="IsDemoHotel(hotel) ? 'red--text' : ''">{{ hotel.name }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import queryString from "querystring";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class ToolbarHotels extends Vue {
  hasHotelAssigned = false;
  searchKeyword = "";
  menuOpen = false;

  @Watch("menuOpen")
  onMenuOpenChange(open: boolean) {
    if (open && this.showSearch) {
      this.searchKeyword = "";
      this.$nextTick(() => {
        (this.$refs.searchField as any)?.focus();
      });
    }
  }
  mounted() {
    this.getMyHotels();
  }
  getMyHotels() {
    this.$store.dispatch("app/getMyHotels");
  }
  get showSearch() {
    return this.hotels && this.hotels.length > 5;
  }
  get state() {
    return this.$store.state.app;
  }
  get hotels() {
    const hotels = this.state.hotels;
    this.hasHotelAssigned = hotels && hotels.length > 0;
    return hotels;
  }
  get filteredHotels() {
    return this.hotels ? this.hotels.filter((hotel) => {
      return hotel?.name
        ?.toLowerCase()
        ?.includes(this.searchKeyword?.toLowerCase());
    }) : null;
  }
  get hotel() {
    return this.state.hotel;
  }
  get selectedHotel() {
    let hotel: any = {};
    if (this.hotels && this.hotels.length > 0) {
      let hotelId = this.$route.query.hotelId;
      // Find default Hotel
      hotel = this.hotels.find((i) => i.default_hotel);
      if (hotel == null || typeof hotel == "undefined"){
        hotel = this.hotels[0];
      }
      if (hotelId) {
        hotel = this.hotels.find((i) => i.id == hotelId);
      }
    }

    if (!this.$route.query.hotelId && hotel.id) {
      this.SetHotel(hotel);
    } else {
      this.setSelectedHotel(hotel);
    }
    return hotel || {};
  }
  IsDemoHotel(hotel){
    return hotel.id <= 100;
  }
  SetHotel(hotel) {
    let query: any = this.$route.query;
    query.hotelId = hotel.id + "";
    let location: any = this.$route.path + "?" + queryString.stringify(query);
    // let route:any = this.$route
    // route.query.hotelId = hotel.id + "";
    // this.$router.push(route);
    window.location.href = location;
  }
  setSelectedHotel(hotel) {
    this.$store.commit("app/setSelectedHotel", hotel);
  }
}
</script>
